
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm3.794 6.885l-4.74 6.03L9.44 11.72a.99.99 0 00-1.596 1.172l2.384 3.247a.99.99 0 001.577.026l5.546-7.056a.99.99 0 10-1.557-1.223z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    